import NewAxiosInstance from "../../../api/api";
import {
  ICampaignLeadGetType,
  ICampaignLeadListFilterTypes,
  ICampaignLeadLogTableType,
  IDispositionForm,
} from "../../../types/campaignTypes";
import { ITablePagination } from "../../../types/commonTypes";
import { obj2url } from "../../../utils/utils";

export const campaignListRequestApi = async (pageData: ITablePagination) => {
  return await NewAxiosInstance().get(
    `/crm/campaign?take=${pageData.take}&skip=${pageData.skip}`
  );
};

export const campaignLeadListApi = async (
  pageData: ITablePagination,
  data: ICampaignLeadListFilterTypes
) => {
  return await NewAxiosInstance().get(
    `/crm/campaign/leads?take=${pageData.take}&skip=${pageData.skip}` +
      obj2url(data)
  );
};

export const getCampaignLeadByIdApi = async (data: ICampaignLeadGetType) => {
  return await NewAxiosInstance().get(`/lead/${data.leadId}`);
};

export const getCampaignLeadDispositionApi = async ({
  pageData,
  data,
}: ICampaignLeadLogTableType) => {
  return await NewAxiosInstance().get(
    `/lead/disposition?take=${pageData.take}&skip=${pageData.skip}&leadId=${data.leadId}`
  );
};

export const addCampaignLeadDispositionApi = async (data: IDispositionForm) => {
  return await NewAxiosInstance().post(`/lead/disposition`, data);
};

export const searchLeadApi = async (data: any) => {
  return await NewAxiosInstance().get(`/lead/?take=100&skip=0` + obj2url(data));
};
